module.exports = __webpack_public_path__ + "media/mjollnir1.3dc121d4.webm";